











































import CClassifiedContactForm from '~/components/shared/configurable/classified/contact/CClassifiedContactForm.vue'
import CMiniMessages from '~/components/shared/configurable/message/CMiniMessages.vue'
import { mapGetters } from 'vuex'
import StatsService from '~/services/stats/StatsService'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CClassifiedContactForm, CMiniMessages },
  props: {
    classifiedId: { type: Number, required: true, default: null },
    inIframe: { type: Boolean, required: false, default: false },
    siteUrl: { type: String, required: false, default: 'car.gr' },
    goToMessagesOnLoad: { type: Boolean, required: false, default: false },
    contactFormExtraText: {
      type: String,
      default: ''
    },
    contactFormButtonText: {
      type: String,
      default: ''
    },
    useStore: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      showMessages: false,
      showForm: true,
      threadOpened: false,
      formIsVisible: false
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      classifiedIsOwn: 'isOwn'
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    })
  },
  created() {
    const shouldLazilyLoad =
      !this.inIframe && !this.classifiedIsOwn && !this.userIsAdmin
    this.formIsVisible = !shouldLazilyLoad
  },
  updated() {
    this.$emit('updated')
  },
  methods: {
    handleContactVisibilityChange(isVisible: boolean) {
      if (isVisible) {
        this.formIsVisible = true
      }
    },
    recordFormSubmitButtonClick() {
      this.$dep(StatsService).record('events.clsfds.contact_form_click', [
        this.classifiedId
      ])
    },
    handleShow(state) {
      if (state === 'both') {
        this.showMessages = true
        this.showForm = true
        this.$emit('form-showing', true)
      } else if (
        state === 'messages-only' ||
        state === 'messages-only-opened'
      ) {
        if (this.showMessages && state === 'messages-only-opened') {
          this.showForm = false
          // refetch threads (admin edge case)
          this.$nextTick(() => this.$refs.messages.refetch())
        } else {
          this.showMessages = true
          this.showForm = false
          this.$emit('form-showing', false)
          this.threadOpened = state === 'messages-only-opened'
        }
      } else if (state === 'contact-only') {
        this.showMessages = false
        this.showForm = true
        this.$emit('form-showing', true)
      }

      this.$nextTick(function() {
        this.$emit('updated')
      })
    }
  }
})
